import React from 'react';
import { Mail, ArrowUp } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const legalLinks = [
    { name: t('footer.links.termsOfUse'), href: '/terms' },
    { name: t('footer.links.privacyPolicy'), href: '/privacy' },
    { name: t('footer.links.refundPolicy'), href: '/refund' },
    { name: t('footer.links.subscriptionTerms'), href: '/subscription' },
    { name: t('footer.links.disclaimer'), href: '/disclaimer' }
  ];

  return (
    <footer className="bg-gray-900 text-white relative">
      {/* 回到顶部按钮 */}
      <button
        onClick={scrollToTop}
        className="absolute -top-6 right-8 bg-orange-500 hover:bg-orange-600 text-white p-3 rounded-full shadow-lg transform hover:scale-110 transition-all duration-300 z-10"
      >
        <ArrowUp className="w-5 h-5" />
      </button>

      {/* 主要内容区 */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-8">
        <div className="text-center">
          {/* 品牌信息 */}
          <div className="flex items-center justify-center mb-6">
            <img 
              src="/images/logo.jpg" 
              alt="AI Monkey Logo" 
              className="w-12 h-12 rounded-xl mr-4"
            />
            <div className="text-left">
              <h2 className="text-2xl font-bold">AI Monkey</h2>
              <p className="text-gray-400 text-sm">{t('footer.serviceDescription')}</p>
            </div>
          </div>

          {/* 联系信息 */}
          <div className="flex items-center justify-center text-gray-300 mb-8">
            <Mail className="w-5 h-5 mr-3 text-orange-500" />
            <span>support@ai2you.org</span>
          </div>

          {/* 政策链接 */}
          <div className="flex flex-wrap justify-center gap-6 mb-8">
            {legalLinks.map((link) => (
              <Link
                key={link.name}
                to={link.href}
                className="text-gray-300 hover:text-orange-500 transition-colors duration-300"
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* 服务地区说明 */}
          <div className="mb-8 p-4 bg-gray-800 rounded-lg max-w-2xl mx-auto">
            <p className="text-gray-400 text-sm">
              {t('footer.serviceNotice')}
            </p>
          </div>

          {/* 版权信息 */}
          <div className="text-gray-400 text-sm">
            <p>&copy; 2024-2025 • AI Monkey</p>
          </div>
        </div>
      </div>
    </footer>
  );
}